import { observer } from "mobx-react";
import BasePageLayout from "../../components/layouts/base-page-layout/base-page-layout";
import { useEffect, useState } from "react";
import SetupNowModal from "./components/set-up-now-modal/set-up-now-modal";
import shipByReturngoPageStore from "./ship-by-returngo-page-store";
import TranslationScope from "../../translation/translation-scope";
import SetUpNowSuccessModal from "./components/set-up-now-success-modal/set-up-now-success-modal";
import SupportedCarriersCard from "./components/supported-carriers-card/supported-carriers-card";
import ListLayout from "../../components/layouts/list-layout/list-layout";
import BenefitsBar from "./components/benefits-bar/benefits-bar";
import ScheduleDemoCard from "./components/schedule-demo-card/schedule-demo-card";
import SetupNowCard from "./components/setup-now-card/setup-now-card";

const ShipByReturnGOPage: React.FC = observer(() => {
    const [showSetUpNowModal, setShowSetUpNowmodal] = useState<boolean>(false);
    const [showSetUpNowSuccessModal, setShowSetUpNowSuccessModal] = useState<boolean>(false);
    
    useEffect(() => {
        shipByReturngoPageStore.load();
    }, []);

    return (
        <BasePageLayout title="Ship by ReturnGO">
            <div className={'sbr-page'}>
                <ListLayout>
                    <ScheduleDemoCard onSetUpClicked={() => setShowSetUpNowmodal(true)} />
                    <BenefitsBar />
                    <SupportedCarriersCard />
                    <SetupNowCard onSetUpClicked={() => setShowSetUpNowmodal(true)} />

                    <TranslationScope scope="return-methods">
                        {showSetUpNowModal && <SetupNowModal 
                            onCloseClicked={() => setShowSetUpNowmodal(false)} 
                            showSetUpNowSuccessModal={() => setShowSetUpNowSuccessModal(true)} />
                        }
                        {showSetUpNowSuccessModal && <SetUpNowSuccessModal />}
                    </TranslationScope>
                </ListLayout>
            </div>
        </BasePageLayout>
    );
});

export default ShipByReturnGOPage;